import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
  Link,
} from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { Expand, Shrink } from "lucide-react";
import { useState } from "react";

// Rendered only while the modal is open (HeroUI unmounts modal content on
// close), so its "loaded" state starts fresh on every open — no effect needed
// to reset it.
function KnowledgeBaseFrame() {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="h-full min-h-[50vh]">
      <iframe
        title={t`Baza znanja`}
        src="https://lime-booking.productfruits.help/sl"
        className="h-full min-h-[50vh] w-full rounded-lg"
        onLoad={() => setIsLoaded(true)}
      />
      {!isLoaded ? (
        <div className="flex items-center justify-center">
          <Spinner />
        </div>
      ) : null}
    </div>
  );
}

export const KnowledgeBaseModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [isKnowledgeBaseFullScreen, setIsKnowledgeBaseFullScreen] =
    useState(false);

  return (
    <Modal
      isOpen={isOpen}
      size={isKnowledgeBaseFullScreen ? "full" : "5xl"}
      onClose={onClose}
      classNames={{
        base: "transition-all duration-300",
        body: "transition-all duration-300",
        header: "transition-all duration-300",
        footer: "transition-all duration-300",
        closeButton: "transition-all duration-300",
        backdrop: "transition-all duration-300",
        wrapper: "transition-all duration-300",
      }}
    >
      <ModalContent>
        <ModalHeader>
          <Trans>Baza znanja</Trans>
        </ModalHeader>
        <ModalBody className="pb-6">
          <div className="mb-1 flex items-center gap-2">
            <Button
              variant="flat"
              isIconOnly
              title={isKnowledgeBaseFullScreen ? t`Skrči` : t`Razširi`}
              aria-label={isKnowledgeBaseFullScreen ? t`Skrči` : t`Razširi`}
              onPress={() =>
                setIsKnowledgeBaseFullScreen(!isKnowledgeBaseFullScreen)
              }
            >
              {isKnowledgeBaseFullScreen ? (
                <Shrink size={16} />
              ) : (
                <Expand size={16} />
              )}
            </Button>
            <Button
              as={Link}
              showAnchorIcon
              href="https://lime-booking.productfruits.help/sl"
              target="_blank"
              variant="flat"
            >
              <Trans>Odpri v novem zavihku</Trans>
            </Button>
          </div>

          <KnowledgeBaseFrame />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
